/**
 * Centralized tracking constants for analytics events across all modules.
 *
 * Usage:
 *   import { TrackingCategory, TrackingAction, TrackingPageType, FilterType } from '@/constants/trackingConstants';
 */

// ─── Event Categories ────────────────────────────────────────
export const TrackingCategory = {
  // Fixed Fees
  FIXED_FEES: 'Fixed Fees',
  TIME_ENTRIES: 'Time Entries',
  FIXED_FEE_LIST: 'Fixed Fee List',
  FIXED_FEE_TAB: 'Fixed Fee Tab',
  FIXED_FEE: 'Fixed Fee',
  FIXED_FEE_TIME_ENTRIES: 'Fixed Fee Time Entries',
  CLIENT_MATTER_LINK: 'Client Matter Link',
  // Time Entries
  BULK_UPDATE_TIME: 'Bulk Update Time',
  // Settlement
  SETTLEMENT_TAB: 'Settlement Tab',
  SETTLEMENT_WIZARD: 'Settlement Wizard',
  // Conflict Check
  CONFLICT_CHECK: 'Conflict Check'
};

// ─── Event Actions ───────────────────────────────────────────
export const TrackingAction = {
  // Fixed Fees
  BULK_OPERATION: 'Bulk Operation',
  CLICKED: 'Clicked',
  VIEWED: 'Viewed',
  CREATED: 'Created',
  COLUMN_SORTED: 'Column Sorted',
  COLUMNS_UPDATED: 'Columns Updated',
  PRINT: 'Print',
  EXPORT: 'Export',
  FILTER_APPLIED: 'Filter Applied',
  // Time Entries
  CHANGE_MATTER: 'Change Matter',
  CONVERT_BILLING_TYPE: 'Convert Billing Type',
  ASSIGN_TO_FIXED_FEE: 'Assign to Fixed Fee',
  ALERT_CLICKED: 'Alert Clicked',
  // Settlement
  PAGE_VIEWED: 'Page Viewed',
  WIZARD_STARTED: 'Wizard Started',
  WIZARD_STEP_VIEWED: 'Wizard Step Viewed',
  WIZARD_STEP_COMPLETED: 'Wizard Step Completed',
  STATEMENT_GENERATED: 'Statement Generated',
  STATEMENT_DOWNLOADED: 'Statement Downloaded',
  SETTLEMENT_UNLOCKED: 'Settlement Unlocked',
  SETTINGS_CHANGED: 'Settings Changed',
  RECOVERY_AMOUNT_ENTERED: 'Recovery Amount Entered',
  // Conflict Check
  PRINTED: 'Printed'
};

// ─── Page Types ──────────────────────────────────────────────
export const TrackingPageType = {
  FIXED_FEE_LIST: 'fixed-fee-list',
  TIME_ENTRIES: 'time-entries'
};

// ─── Filter Types ────────────────────────────────────────────
export const FilterType = {
  // Fixed Fees
  CLIENT_MATTER: 'client-matter',
  BILLED_STATUS: 'billed-status',
  TIME_LOCK_STATUS: 'time-lock-status',
  COMPLETION_STATUS: 'completion-status',
  FEE_TYPE: 'fee-type',
  PRACTICE_AREA: 'practice-area',
  INVOICE_USER: 'invoice-user',
  RESPONSIBLE_ATTORNEY: 'responsible-attorney',
  BILLABLE_DATE: 'billable-date',
  CUSTOM_FIELD: 'custom-field',
  CLEAR_ALL: 'clear-all',
  // Time Entries
  FIXED_FEE_ASSIGNMENT: 'fixed_fee_assignment'
};